import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { RoleExplainerView } from './components/RoleExplainerView';
import { ReaderView } from './components/ReaderView';
import { TaskMatrixView } from './components/TaskMatrixView';
import { DocumentGraphView } from './components/DocumentGraphView';
import { VisualGalleryView } from './components/VisualGalleryView';
import { MermaidLightboxModal } from './components/MermaidLightboxModal';
import { CommandPaletteModal } from './components/CommandPaletteModal';
import { useWorkspaceStore } from './stores/useWorkspaceStore';
import { useUIStore } from './stores/useUIStore';
import { BenchmarkService } from './services/BenchmarkService';

export const App: React.FC = () => {
  const { currentPackage, setPackage, isLoading } = useWorkspaceStore();
  const { activeTab } = useUIStore();

  useEffect(() => {
    // Auto-load PostMQ preset on initial launch
    const loadDefaultPreset = async () => {
      try {
        const pkg = await BenchmarkService.loadPreset('postmq');
        setPackage(pkg);
      } catch (err) {
        console.error('Failed to load default preset:', err);
      }
    };

    if (!currentPackage) {
      loadDefaultPreset();
    }
  }, [currentPackage, setPackage]);

  return (
    <div className="flex flex-col h-screen w-screen bg-slate-950 text-slate-100 overflow-hidden font-sans">
      {/* Header Bar */}
      <Header />

      {/* Main Workspace Frame */}
      <div className="flex flex-1 overflow-hidden relative">
        {/* Left Navigation Sidebar */}
        <Sidebar />

        {/* Dynamic View Tab Panel */}
        <main className="flex-1 flex flex-col overflow-hidden bg-slate-900/30">
          {isLoading ? (
            <div className="flex-1 flex items-center justify-center p-8 text-xs font-mono text-cyan-400">
              <div className="flex items-center space-x-2">
                <div className="w-4 h-4 rounded-full border-2 border-cyan-400 border-t-transparent animate-spin" />
                <span>Parsing Specification Package...</span>
              </div>
            </div>
          ) : activeTab === 'explainer' ? (
            <RoleExplainerView />
          ) : activeTab === 'reader' ? (
            <ReaderView />
          ) : activeTab === 'tasks' ? (
            <TaskMatrixView />
          ) : activeTab === 'graph' ? (
            <DocumentGraphView />
          ) : (
            <VisualGalleryView />
          )}
        </main>
      </div>

      {/* Lightbox & Command Palette Modals */}
      <MermaidLightboxModal />
      <CommandPaletteModal />
    </div>
  );
};
